import { __decorate, __extends } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import Popup from '@/components/messageBox/popup';

var CommonPopup =
/** @class */
function (_super) {
  __extends(CommonPopup, _super);

  function CommonPopup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 默认不勾选 */


    _this.neverDisplay = false;
    return _this;
  }
  /**
   * 点击关闭
   */


  CommonPopup.prototype.onClickClose = function () {
    this.value = false; // 调用callback

    if (this.closeCb) {
      this.closeCb({
        neverDisplay: this.neverDisplay
      });
    } // 重置neverDisplay


    this.neverDisplay = false;
  };

  CommonPopup.prototype.onClickNeverDisplay = function () {
    this.neverDisplay = !this.neverDisplay;
  };

  __decorate([Prop({
    type: String,
    "default": ''
  })], CommonPopup.prototype, "title", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], CommonPopup.prototype, "desc", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], CommonPopup.prototype, "src", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], CommonPopup.prototype, "desc2", void 0);

  __decorate([Prop({
    type: String,
    "default": ''
  })], CommonPopup.prototype, "actionText", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], CommonPopup.prototype, "neverDisplayVisible", void 0);

  __decorate([Prop({})], CommonPopup.prototype, "actionCb", void 0);

  __decorate([Prop({})], CommonPopup.prototype, "closeCb", void 0);

  CommonPopup = __decorate([Component({
    name: 'CommonPopup',
    template: "<MyPopup v-model=\"value\" class=\"qrcode-popup\" position=\"center\" :modal=\"true\">\n        <div class=\"qrcode-content\">\n            <div v-if=\"title\" class=\"qrcode-title\">{{title}}</div>\n            <div v-if=\"desc\" class=\"qrcode-desc\" v-html=\"desc\"></div>\n            <img v-if=\"src\" class=\"qrcode-img\" :src=\"src\" />\n            <div v-if=\"desc2\" class=\"qrcode-desc2\" v-html=\"desc2\"></div>\n\n            <!-- \u4E0D\u518D\u63D0\u793A -->\n            <div v-if=\"neverDisplayVisible\" class=\"qrcode-never-display gray-color\">\n                <MobileButton name=\"line-normal\" class=\"btn-small\" @click=\"onClickNeverDisplay\">\n                    <i class=\"icon\" :class=\"{'gray-color': neverDisplay}\">{{neverDisplay ? '&#xe604;' : '&#xe603;'}}</i>\n                    \u4E0D\u518D\u63D0\u793A\n                </MobileButton>\n            </div>\n            <div v-if=\"actionText\" class=\"action-btn-wrap\">\n                <MobileButton @click=\"actionCb\" name=\"red-gradient\" class=\"btn-normal btn-round action\">{{actionText}}</MobileButton>\n            </div>\n            <i class=\"qrcode-close icon\" @click=\"onClickClose\">\n                &#xe64b;\n            </i>\n        </div>\n    </MyPopup>"
  })], CommonPopup);
  return CommonPopup;
}(Mixins(Popup));

export { CommonPopup };